import React, { Component } from "react";
import ReportTableHeader from "./../ReportTableHeader";
import ReportTablePivot from "../ReportTablePivot";
import ReportTableDaysContent from "./ReportTableDaysContent";
import ReportTableDashboards from "../ReportTableDashboard";
import ReportTableUnitInfo from "../ReportTableUnitInfo";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./../reportTable.module.scss";

class ReportTable extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { scrollbar } = this.refs;

    scrollbar.scrollTop(this.props.scroll);
  }

  componentWillUnmount() {
    const { scrollbar } = this.refs;
    const { unitId } = this.props;
    this.props.onSetSctollUnitReport(unitId, scrollbar.getScrollTop());
  }

  render() {
    const { data, buildType, height = 450 } = this.props;

    return (
      <div className={styles.reportTableContainer}>
        <ReportTableUnitInfo info={data.info} />
        <ReportTableDashboards dashboards={data.dashboard} />
        <ReportTableHeader header={data.header} />

        <Scrollbars style={{ height: height + "px" }} autoHide={false} ref="scrollbar">
          <ReportTableDaysContent days={data.days} />
          <ReportTablePivot pivot={data.pivot} />
        </Scrollbars>
      </div>
    );
  }
}

export default ReportTable;
